<template>
  <div id="ForgotPassword" class="layout-login">
    <v-row align="center" justify="center"
      ><v-col cols="12">
        <v-card color="primary" max-width="700" class="pa-4" dark
          ><v-card-text
            ><v-row align="stretch" justify="center"
              ><v-col cols="6">
                <div class="layout-btn">
                  <h1 class="text-h4 mb-4">GULF VENDOR PORTAL</h1>
                  <p>Gulf Development Public Company Limited</p>
                  <div class="card-btn">
                    <v-card
                      color="#304765"
                      class="icon-btn mr-4"
                      @click="gotoPage('vendorguide')"
                      ><v-card-text>
                        <v-icon color="secondary" x-large dark
                          >mdi-book-open-page-variant-outline</v-icon
                        >
                        <p class="mt-3">Vendor Guide</p>
                      </v-card-text></v-card
                    >
                    <v-card
                      color="#304765"
                      class="icon-btn"
                      @click="gotoPage('announcement')"
                      ><v-card-text>
                        <v-icon color="secondary" x-large dark
                          >mdi-bullhorn</v-icon
                        >
                        <p class="mt-3">Announcement</p>
                      </v-card-text></v-card
                    >
                  </div>
                </div> </v-col
              ><v-col cols="6">
                <v-card color="#304765"
                  ><v-card-text
                    ><h1 class="text-h5 mb-4">Forgot your password ?</h1>
                    <p>
                      Please enter your Username and we'll send you a new password to your registered email.
                      (Username is your Tax ID and Branch ID.)
                    </p>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                        light
                        solo
                        dense
                        v-model="userName"
                        :counter="18"
                        :rules="[(v) => !!v || 'Username  is required']"
                        label="Username"
                        required
                      ></v-text-field
                      ><v-btn
                        color="#0B1D35"
                        class="mr-4"
                        @click="validate"
                        block
                      >
                        Submit
                      </v-btn>
                    </v-form>
                    <div class="text-center mt-4">
                      Not registered yet ?
                      <a class="secondary--text" @click="gotoPage('register')"
                        >Register
                      </a>
                      <br />
                      <a class="secondary--text" @click="gotoPage('')"
                        >Back to Login
                      </a>
                    </div></v-card-text
                  ></v-card
                ></v-col
              ></v-row
            ></v-card-text
          ></v-card
        ></v-col
      ></v-row
    >
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="grey lighten-2">
          Confirm to Reset Password.
        </v-card-title>
        <v-card-text class="mt-4"
          >Your password will be reset and send to your registered email.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submit">Accept</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { vendorservice } from "../services/vendorservice";
export default {
  name: "ForgotPassword",
  data: () => ({
    userName: "",
    dialog: false,
    valid: true,
  }),
  methods: {
    gotoPage(page) {
      this.$router.push(`/${this.$i18n.locale}/${page}`).catch(() => {});
    },

    async submit() {
      this.dialog = false;
      this.$loading(true);
      let response = await vendorservice.ForgotPassword(this.userName);
      if (response) {
        this.$notify({
          title: "Resend password success",
          text: "Success",
          type: "success",
        });
        // Redirect to login page
        this.gotoPage("");
      } else {
        this.$notify({
          title: "Resend password failed",
          text: "Username does not exist",
          type: "error",
        });
      }

      this.$loading(false);
    },
    async validate() {
      await this.$refs.form.validate();
      if (this.valid === true) {
        this.dialog = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-login {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > .image {
    height: 100vh;
    position: fixed;
    top: 0;
  }
  > .image-logo {
    position: fixed;
    width: 150px;
    top: 3rem;
    left: 3rem;
  }
}
.icon-btn {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-content: center;
  text-align: center;
  width: 100%;
}
.card-btn {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.layout-btn {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
